import { useMemo } from "react";

export default function useStrapGeometry(config, scale) {
    return useMemo(() => {
        const vWidth = config.width * scale;
        const vBuckleWidth = (config.buckleWidth || config.width) * scale;
        const vShort = config.shortLength * scale;
        const vLong = config.longLength * scale;
        const fullW = Math.max(vWidth, vBuckleWidth);
        const lugOff = (fullW - vWidth) / 2;
        const bucOff = (fullW - vBuckleWidth) / 2;
        const faceGap = 18 * scale;
        const horizontalGap = 4 * scale;
        const currentTotalWidth = (fullW * 2) + horizontalGap;
        const currentTotalHeight = Math.max(vShort, vLong);
        const sw = (0.75 * scale) / 2;
        const tipH = 26 * scale;
        const shortPoints = `${bucOff + sw},${sw} ${bucOff + vBuckleWidth - sw},${sw} ${lugOff + vWidth - sw},${vShort - sw} ${lugOff + sw},${vShort - sw}`;
        const previewClipPathShort = `polygon(${bucOff}px 0px, ${bucOff + vBuckleWidth}px 0px, ${lugOff + vWidth}px ${vShort}px, ${lugOff}px ${vShort}px)`;
        const longPath = `M ${lugOff + sw} ${sw} L ${lugOff + vWidth - sw} ${sw} L ${bucOff + vBuckleWidth - sw} ${vLong - tipH} Q ${bucOff + vBuckleWidth - sw} ${vLong - tipH * 0.3} ${fullW / 2} ${vLong - sw} Q ${bucOff + sw} ${vLong - tipH * 0.3} ${bucOff + sw} ${vLong - tipH} Z`;
        const previewClipPathLong = `path('M ${lugOff} 0 L ${lugOff + vWidth} 0 L ${bucOff + vBuckleWidth} ${vLong - tipH} Q ${bucOff + vBuckleWidth} ${vLong - tipH * 0.3} ${fullW / 2} ${vLong - 1.5} Q ${bucOff} ${vLong - tipH * 0.3} ${bucOff} ${vLong - tipH} Z')`;
        const maxAssumedShort = 110 * scale;
        const maxAssumedLong = 160 * scale;
        return {
            vWidth, vBuckleWidth, vShort, vLong,
            fullW, lugOff, bucOff,
            taperOffsetTop: bucOff, // backward compat (same as bucOff)
            faceGap, horizontalGap,
            currentTotalWidth, currentTotalHeight,
            sw, tipH, strokeWidth: sw * 2,
            shortPoints, previewClipPathShort,
            longPath, previewClipPathLong,
            maxAssumedShort, maxAssumedLong,
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scale, config.width, config.buckleWidth, config.shortLength, config.longLength]);
}
